import { useEffect } from 'react';
import { UserSecurity, WorkOsWidgets } from '@workos-inc/widgets';

import { DescriptionHeader } from '../../features/user/components/description-header';
import { uiStore } from '../../core/stores/ui-store';
import { useAuth } from '../../workos-auth';

export const SecurityPage = () => {
  const { getAccessToken } = useAuth();

  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Password and authentication',
    };

    uiStore.showBack = true;
  }, []);

  return (
    <>
      <DescriptionHeader
        title="Password and two-factor authentication"
        description="Use email and password to log in to PRODUCER."
      />

      <WorkOsWidgets
        theme={{
          appearance: 'dark',
          accentColor: 'green',
          radius: 'medium',
          fontFamily: 'Inter',
        }}
      >
        <UserSecurity authToken={getAccessToken} />
      </WorkOsWidgets>
    </>
  );
};
